export default {
  promotions: [],
  letters: [],
  lettersCount: 0,
  bonuses: [],
  bonusesCount: 0,
}
